import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import ReactPlayer from 'react-player';

import SubmitButton from '../common/SubmitButton';
import Alerts from '../common/Alerts';
import Translation from '../common/Translation';
import CancelButton from '../common/CancelButton';
import Input from '../common/Input';
import { nameofFactory } from '../../helpers/nameOfFactory';
import * as enums from '../../common/enums';
import { BaseDetailProps } from '../common/types/baseDetail';
import DropDown from '../common/DropDown';
import TargetedCampaign from '../../entities/targetedCampaign';

const nameof = nameofFactory<TargetedCampaign>();

export interface TargetCampaignDetailDetailProps extends BaseDetailProps<TargetedCampaign>, TargetCampaignDetailDetailStateProps {
    headerText: string;
}

export interface TargetCampaignDetailDetailStateProps {
    lang: string;
}

class TargetCampaignDetailDetail extends Component<TargetCampaignDetailDetailProps> {
    handleOnSubmit = (values: object) => {
        this.props.submitAction(values as TargetedCampaign);
    };

    handleOnCancel = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();

        this.props.cancelAction();
    };

    translatedFormValidation = (values: object) => {
        const { t } = this.props;

        const typedValues = values as TargetedCampaign;
        const errors: Partial<Record<keyof TargetedCampaign, string>> = {};

        if (!typedValues.msisdn) {
            errors.msisdn = t('ValueIsRequired');
        }

        if (typedValues.msisdn && (!typedValues.msisdn.startsWith('420') || typedValues.msisdn.length != 12)) {
            errors.msisdn = t('Invalid format (420123456789)');
        }

        if (!typedValues.campaignCodeDescription) {
            errors.campaignCodeDescription = t('ValueIsRequired');
        }

        return errors;
    };

    render() {
        const { initialValues, headerText, cancelAction } = this.props;

        return (
            <div>
                <div className="content-header">
                    <h1>{headerText}</h1>
                </div>
                <div className="content-wrapper">
                    <Alerts />
                    <div className="panel card col-xs-12 col-sm-6">
                        <Form
                            validate={this.translatedFormValidation}
                            onSubmit={this.handleOnSubmit}
                            initialValues={initialValues}
                            render={({ handleSubmit, form }) => (
                                <form className="k-form" onSubmit={handleSubmit}>
                                    <label className="k-form-field" htmlFor={nameof('msisdn')}>
                                        <span>
                                            <Translation tKey="Msisdn" />
                                        </span>
                                        <Field name={nameof('msisdn')} component={Input} />
                                    </label>

                                    <label className="k-form-field" htmlFor={nameof('campaignCodeDescription')}>
                                        <span>
                                            <Translation tKey="CampaignCode" />
                                        </span>
                                        <Field
                                            name={nameof('campaignCodeDescription')}
                                            component={DropDown}
                                            textField="text"
                                            dataSource={enums.TARGETED_CAMPAIGN_CODES}
                                        />
                                    </label>

                                    <div className="footer">
                                        <SubmitButton loading={form.getState().submitting}>
                                            <Translation tKey="Save" />
                                        </SubmitButton>
                                        <CancelButton onClick={this.handleOnCancel}>
                                            <Translation tKey="Cancel" />
                                        </CancelButton>
                                    </div>
                                </form>
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any): TargetCampaignDetailDetailStateProps => {
    return {
        lang: state.app.lang,
    };
};

export default connect(mapStateToProps)(TargetCampaignDetailDetail);
